/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-unused-vars */
export enum REPAYMENT_FREQUENCY {
  MONTHLY = 'MONTHLY',
  WEEKLY = 'WEEKLY',
  FORTNIGHTLY = 'FORTNIGHTLY',
}
